import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const INSTAGRAM_URL = 'https://www.instagram.com/innoflextechnology?igsh=YmRtb2FyemVldm40';
const WHATSAPP_DR = 'https://wa.me/18495388899?text=Hola%20InnoFlex!%20Me%20gustar%C3%ADa%20una%20demo%20gratis.';
const LOGO_URL = 'https://public.readdy.ai/ai/img_res/30ce4755-e8b9-4ea3-9fec-24f4c0149c4e.png';

const handleNavClick = (href: string) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

export default function Footer() {
  const { t } = useTranslation();

  const footerLinks = {
    [t('footer_cat_solutions')]: [
      { labelKey: 'footer_l_billing', href: '#services', isRoute: false },
      { labelKey: 'footer_l_custom', href: '#services', isRoute: false },
      { labelKey: 'footer_l_consulting', href: '#services', isRoute: false },
    ],
    [t('footer_cat_industries')]: [
      { labelKey: 'footer_l_restaurants', href: '/industrias#restaurantes', isRoute: true },
      { labelKey: 'footer_l_supermarkets', href: '/industrias#supermercados', isRoute: true },
      { labelKey: 'footer_l_hardware', href: '/industrias#ferreterias', isRoute: true },
      { labelKey: 'footer_l_distributors', href: '/industrias#dealers', isRoute: true },
      { labelKey: 'footer_l_industries_all', href: '/industrias', isRoute: true },
    ],
    [t('footer_cat_company')]: [
      { labelKey: 'footer_l_why', href: '#why', isRoute: false },
      { labelKey: 'footer_l_blog', href: '/blog', isRoute: true },
      { labelKey: 'footer_l_testimonials', href: '#testimonials', isRoute: false },
      { labelKey: 'footer_l_pricing', href: '#pricing', isRoute: false },
      { labelKey: 'footer_l_faq', href: '#faq', isRoute: false },
      { labelKey: 'footer_l_contact', href: '#contact', isRoute: false },
    ],
  };

  return (
    <footer className="bg-navy-900 border-t border-navy-700 pt-10 sm:pt-16 pb-8 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">

        {/* Main grid: company info + 3 link columns */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-6 md:gap-10 mb-8 md:mb-12">

          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="flex items-center justify-center">
                <img
                  src={LOGO_URL}
                  alt="InnoFlex"
                  className="h-10 sm:h-12 w-auto object-contain"
                  style={{ filter: 'brightness(1.4) drop-shadow(0 0 8px rgba(0,207,255,0.5))' }}
                />
              </div>
              <div className="flex flex-col leading-none">
                <span className="font-heading text-xl sm:text-2xl font-extrabold text-white tracking-tight">
                  Inno<span className="text-electric">Flex</span>
                </span>
              </div>
            </div>
            <p className="font-body text-xs sm:text-sm text-white/50 leading-relaxed mb-4 max-w-xs">
              {t('footer_desc')}
            </p>
            <div className="flex items-start gap-2 mb-5">
              <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                <i className="ri-map-pin-2-line text-electric text-sm"></i>
              </div>
              <p className="font-body text-xs text-white/40 leading-relaxed">
                C/Cervantes No. 203, Local 2-C, Gazcue,<br />Sto. Dgo, D.N — República Dominicana
              </p>
            </div>
            <a
              href={WHATSAPP_DR}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-2 bg-[#25D366]/15 hover:bg-[#25D366]/25 border border-[#25D366]/30 text-[#25D366] text-xs sm:text-sm font-semibold px-4 py-2.5 rounded-full transition-colors duration-200 cursor-pointer whitespace-nowrap font-body"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-whatsapp-line text-base"></i>
              </div>
              {t('footer_contact_btn')}
            </a>
          </div>

          {/* Link Groups — 3 columns in one row on mobile, individual cols on md+ */}
          <div className="grid grid-cols-3 gap-4 md:col-span-3 md:grid-cols-3 md:gap-10">
            {Object.entries(footerLinks).map(([category, links]) => (
              <div key={category}>
                <h4 className="font-heading text-xs sm:text-sm font-bold text-white mb-3 sm:mb-4">
                  <a href={links[0].href}>{category}</a>
                </h4>
                <ul className="space-y-2 sm:space-y-3">
                  {links.map((link) => (
                    <li key={link.labelKey}>
                      {link.isRoute ? (
                        <Link
                          to={link.href}
                          className="font-body text-[11px] sm:text-sm text-white/50 hover:text-electric transition-colors duration-200 cursor-pointer text-left leading-snug block"
                        >
                          {t(link.labelKey)}
                        </Link>
                      ) : (
                        <button
                          onClick={() => handleNavClick(link.href)}
                          className="font-body text-[11px] sm:text-sm text-white/50 hover:text-electric transition-colors duration-200 cursor-pointer text-left leading-snug"
                        >
                          {t(link.labelKey)}
                        </button>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-navy-700 pt-6 sm:pt-8 flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4">
          <p className="font-body text-xs text-white/35 text-center sm:text-left">
            &copy; {new Date().getFullYear()} InnoFlex. {t('footer_rights')}
          </p>
          <div className="flex items-center gap-3 sm:gap-4">
            <div className="flex items-center gap-3 sm:gap-4">
              <a
                href={WHATSAPP_DR}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-11 h-11 flex items-center justify-center rounded-full bg-navy-700 hover:bg-electric/20 text-white/60 hover:text-electric transition-colors duration-200 cursor-pointer"
                aria-label="WhatsApp InnoFlex"
              >
                <i className="ri-whatsapp-line text-xl pointer-events-none"></i>
              </a>
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-11 h-11 flex items-center justify-center rounded-full bg-navy-700 hover:bg-electric/20 text-white/60 hover:text-electric transition-colors duration-200 cursor-pointer"
                aria-label="Instagram InnoFlex"
              >
                <i className="ri-instagram-line text-xl pointer-events-none"></i>
              </a>
              <a
                href="mailto:innoflextechnology@innoflexapp.com"
                rel="nofollow"
                className="w-11 h-11 flex items-center justify-center rounded-full bg-navy-700 hover:bg-electric/20 text-white/60 hover:text-electric transition-colors duration-200 cursor-pointer"
                aria-label="Correo InnoFlex"
              >
                <i className="ri-mail-line text-xl pointer-events-none"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
